import React, {Component, PropTypes} from 'react';
import {Table} from '@sketchpixy/rubix';
import _ from 'lodash';

import Role from './Role/Role';

class Roles extends Component {
  render() {
    return (
        <Table
            bordered
            style={{textAlign: 'center', verticalAlign: 'middle'}}>
          <thead>
          <tr>
            <th style={{textAlign: 'center', verticalAlign: 'middle'}}>활성화</th>
            <th style={{textAlign: 'center', verticalAlign: 'middle'}}>Role Name</th>
            <th style={{textAlign: 'center', verticalAlign: 'middle'}}>Locale</th>
          </tr>
          </thead>
          <tbody>
          {
            this.props.roles.map(role => {
              const index = _.findIndex(this.props.roleLocalePairs, {roleId: role.roleId});
              let countryCode = null;
              if (index >= 0) {
                countryCode = this.props.roleLocalePairs[index].countryCode;
              }

              return (
                  <Role
                      key={role.roleId}
                      role={role}
                      serviceRegions={this.props.serviceRegions}
                      checked={index >= 0}
                      countryCode={countryCode}
                      roleMappedChangeHandler={this.props.roleMappedChangeHandler}
                      localeChangeHandler={this.props.localeChangeHandler}
                  />
              )
            })
          }
          </tbody>
        </Table>
    );
  }
}

Roles.propTypes = {
  roles: PropTypes.array.isRequired,
  serviceRegions: PropTypes.array,
  roleLocalePairs: PropTypes.array,
  roleMappedChangeHandler: PropTypes.func.isRequired,
  localeChangeHandler: PropTypes.func,
};

export default Roles;



// WEBPACK FOOTER //
// ./src/routes/permission/RoleGroups/RoleGroup/Roles/Roles.js